import { useMemo } from 'react';

import useGetSearchColumns from '@/hooks/useGetSearchColumns';
import { useAppSelector } from '@/redux/hooks';
import { getItemSummaryMap } from '@/redux/modules/item/summary/itemSummary.selectors';
import { getSearchedAndPromotedItems } from '@/redux/modules/search/aggregateResults/searchAggregate.selectors';
import { getImageUrl } from '@/utils/urls';

const MAX_SOLD_ITEMS_TO_DISPLAY = 3;
const DEFAULT_PLACEHOLDER_IMAGE_URL = 'https://p1.liveauctioneers.com/dist/images/placeholder.jpg';

export const useImageUrls = () => {
    const columns = useGetSearchColumns({ isOnSearchPage: true });
    const searchPageItemIds = useAppSelector((state) => getSearchedAndPromotedItems(state, columns));
    const itemCardData = useAppSelector((state) => getItemSummaryMap(state, searchPageItemIds));

    return useMemo(() => {
        const itemSummaries = searchPageItemIds
            .slice(0, MAX_SOLD_ITEMS_TO_DISPLAY)
            .map((itemId) => itemCardData[itemId])
            .filter(Boolean);

        return itemSummaries.map(({ catalogId, imageVersion, itemId, photos, sellerId }) => {
            const firstPhotoId = photos?.[0];

            return firstPhotoId
                ? getImageUrl({
                      catalogId,
                      height: 380,
                      imageNumber: firstPhotoId,
                      imageVersion,
                      itemId,
                      quality: 80,
                      sellerId,
                      sharpen: true,
                      width: 380,
                  })
                : `${DEFAULT_PLACEHOLDER_IMAGE_URL}?height=380&quality=80&sharpen=true&width=380`;
        });
    }, [searchPageItemIds, itemCardData]);
};
